import { Api, GenericHttpResult } from '@agunity/api-v4';
import { AxiosHttpClient } from './axiosHttpClient';
import { apiUrl, isProd } from './environments';
import {
  ROOT_PATHS,
  SYSTEM_UNAVAILABLE_STATUS,
  UNAUTHORIZED,
} from '../Constants';

export interface ExtendedError extends Error {
  response?: {
    status: number;
    data: string;
  };
}

export interface ApiError { errorCode: number, description: string };

class CommonDataManager {
  private static _apiService: Api<AxiosHttpClient>;
  private static _isAuthenticated: boolean = false;
  // eslint-disable-next-line no-unused-vars
  private static errorEvent?: <T>(err: Error) => GenericHttpResult<T>;

  /**
   * @returns {CommonDataManager}
   */
  static getApiInstance(): Api<AxiosHttpClient> {
    if (!CommonDataManager._apiService) {
      const apiClient = new AxiosHttpClient();
      apiClient.onError = (err: ExtendedError) => {
        const error = err as any;
        const isVersionAPI = (error?.request?.responseURL || '').includes(
          '/api/Online/V1.1/Version'
        );
        const code = err?.response?.status;
        if ((err?.response?.data as unknown as ApiError)?.errorCode === 25) {
          console.log('No License unavailable', err);
          if (window.location.href.indexOf(ROOT_PATHS.NO_LICENSE) === -1)
            window.location.href = ROOT_PATHS.NO_LICENSE;
        } else if (code === UNAUTHORIZED) {
          window.location.href = ROOT_PATHS.LOGIN;
        } else if (code === SYSTEM_UNAVAILABLE_STATUS && isVersionAPI) {
          console.log('System unavailable', err);
          window.location.href = ROOT_PATHS.SYSTEM_UNAVAILABLE;
        }
        if (CommonDataManager.errorEvent) {
          return CommonDataManager.errorEvent(err);
        }
        throw err;
      };

      CommonDataManager._apiService = new Api<AxiosHttpClient>(apiClient);

      CommonDataManager._apiService.securityToken$.subscribe(token => {
        CommonDataManager._isAuthenticated = !!token;
      });
    }

    return CommonDataManager._apiService;
  }

  // eslint-disable-next-line no-unused-vars
  public static addErrorEvent(event: <T>(err: Error) => GenericHttpResult<T>) {
    CommonDataManager.errorEvent = event;
  }

  static get isAuthenticated() {
    return CommonDataManager._isAuthenticated;
  }
}

// Create an instance of the API class with your HTTP client
export const apiService: Api<AxiosHttpClient> = CommonDataManager.getApiInstance();
export const addErrorEvent = CommonDataManager.addErrorEvent;

export const isAuthenticated: () => boolean = () => CommonDataManager.isAuthenticated;

if (!isProd) {
  // prod should have n logging active
  console.warn('api = ' + apiUrl);
}